import FriendlyMessage from "./friendly-message";
import progressiveLoad from "./higher-order/progressive-load";
import pure from "./higher-order/pure";
import React from "react";
import TournamentListItem from "./tournament-list-item";
import TournamentListHeader from "./tournament-list-header";

export default pure(progressiveLoad(2, function TournamentList({ frame, location, tournaments }) {
  var ts = tournaments;
  if (frame === 0) {
    ts = tournaments.take(5);
  }
  if (tournaments.count() === 0) {
    return <NoTournamentsFound location={location} />;
  }
  return (
    <div className="tournament-table_wrapper">
      <TournamentListHeader />

      <div className="tournament-table_list">
        {ts.map((t, position) => <TournamentListItem key={t.get("id")} position={position} tournament={t} />)}
      </div>
    </div>
  );
}));

var NoTournamentsFound = pure(function NoTournamentsFound({ location }) {
  return (
    <div className="tournament-table_wrapper">
      <div className="tournament-table tournament-table--header" />

      <div className="padding-top--is-40 padding-bottom--is-20">
        <FriendlyMessage buttonText="Clear Filters" title="No matching tournaments found." url={location.pathname} />
      </div>
    </div>
  );
});
